import "./App.css";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import EventAttendance from './component/EventAttendance';
import AdminLogin from './component/AdminLogin';
import AdminDashboard from './component/AdminDashboard';
import AllSubmissions from './component/AllSubmissions';
import AdminUpload from './component/AdminUpload';
import UserForm from './component/UserForm';
import UserFormSubmissions from './component/UserFormSubmissions';
import GuestRegistrations from './component/GuestRegistrations';

function App() {
  return (
    <Router>
      <div>
       

        <Routes>
          <Route path="/" element={<EventAttendance />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/submissions" element={<AllSubmissions />} />
          <Route path="/admin/user-form-submissions" element={<UserFormSubmissions />} />
          <Route path="/admin/guest-registrations" element={<GuestRegistrations />} />
          <Route path="/admin/upload" element={<AdminUpload />} />
          <Route path="/user/form" element={<UserForm />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;